
      <template>
        <svg v-on="$listeners" xmlns="http://www.w3.org/2000/svg" id="codacy-white-logo" viewBox="0 0 35 35"><defs/><path d="M5.66 14.32a12.28 12.28 0 0 1 5.7-7.44L8.74 2.33A17.54 17.54 0 0 0 .59 12.95ZM14.32 5.67a12.29 12.29 0 0 1 3.16-.41V.01a17.51 17.51 0 0 0-4.52.59ZM20.67 5.67a12.27 12.27 0 0 1 7.42 5.71l4.55-2.63A17.53 17.53 0 0 0 22.04.6ZM0 17.5a17.54 17.54 0 0 0 .59 4.52l5.07-1.36a12.21 12.21 0 0 1-.41-3.17H0ZM2.34 26.26a17.55 17.55 0 0 0 2.77 3.62l3.71-3.71a12.46 12.46 0 0 1-1.95-2.53ZM8.74 32.66A17.37 17.37 0 0 0 17.47 35v-5.25a12.17 12.17 0 0 1-6.11-1.64ZM28.08 23.64a12.27 12.27 0 0 1-7.43 5.69l1.36 5.07a17.53 17.53 0 0 0 10.61-8.14ZM34.38 22.21a17.56 17.56 0 0 0 0-9.08l-5.08 1.36a12.26 12.26 0 0 1 0 6.36Z" class="cls-1"/></svg>
      </template>
      <script>
      export default {
        name: 'VueSvg',
      }
      </script>
    